import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../../../authenticationModule/services/authentication.service';
import {TableService} from '../../../../services/table.service';
import {SelectItem} from 'primeng/api';
import {UtilsService} from '../../../../appSharedModule/services/utils.service';
import {environment} from '../../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute} from '@angular/router';
import {Company} from '../../../../models/company';
import {AssignmentService} from '../../../services/assignment.service';
import {WorkVisitService} from '../../../services/work-visit.service';
import {TechnicalPopService} from '../../../../services/technical-pop.service';
import {firstValueFrom} from 'rxjs';

@Component({
  selector: 'assignment-visit-list',
  templateUrl: './assignment-list.component.html',
  styleUrls: ['./assignment-list.component.scss'],
  host: {class: 'sym-page'}
})
export class AssignmentListComponent implements OnInit {
  listClients: Company[];
  loading = false;
  error = false;
  errorMessage = '';
  cols = [
    {field: 'cabinetName', header: 'Cabinet name', sortable: true},
    {field: 'cage', header: 'Cage', sortable: true},
    {field: 'technicalPop', header: 'Technical POP', sortable: true},
    {field: 'accessCode', header: 'Access code', sortable: true},
    {field: 'coi', header: 'Certificate of Insurance', sortable: false},
    {field: 'workVisitRequest', header: 'Latest work visit request', sortable: true},
  ];
  isMckayUser = false;
  listClientsForClientDropDown: SelectItem[];
  selectedClientUniqid: any;
  selectedClient: Company;
  assignments: any[];
  loadingCois = true;
  cois: any[] = [];

  constructor(private authenticationService: AuthenticationService,
              private utilsService: UtilsService,
              private route: ActivatedRoute,
              private assignmentService: AssignmentService,
              private workVisitService: WorkVisitService,
              private http: HttpClient,
              private tableService: TableService,
              public technicalPopService: TechnicalPopService) {
  }

  ngOnInit() {
    this.utilsService.lockUi();
    this.isMckayUser = this.authenticationService.getUserCurrent().permissions.isMckayUser;
    if (this.isMckayUser) {
      this.loadListClients();
    } else {
      const client = this.authenticationService.getUserCurrent().company;
      this.cols.push({field: 'actions', header: 'Actions', sortable: false});
      this.loadTables(client);
    }
  }

  private loadTables(client: Company) {
    this.utilsService.lockUi();
    this.assignmentService.getAssignmentsByClient(client.uniqid).subscribe(res => {
      this.assignments = res;
      this.utilsService.unlockUi();
    });
    this.workVisitService.getCois(client.uniqid).subscribe(res => {
      this.cois = res;
      this.loadingCois = false;
    });
  }

  loadListClients() {
    const companyUrl = environment.baseUrlWs + '/api/clients-dropdown';
    this.utilsService.cacheablePromise(() => firstValueFrom(this.http.get<any>(companyUrl)),
      'companiesDropDown__' + this.authenticationService.userImpersonatedId, true)
      .then(
        response => {
          this.listClients = response['member'].filter(client => client.isActive);
          this.listClientsForClientDropDown = [];
          this.listClients.forEach((client: Company) => {
            if (client.uniqid !== 'admin') {
              this.listClientsForClientDropDown.push({
                label: client.name,
                value: client.uniqid,
              });
            }
          });
          this.listClientsForClientDropDown = this.listClientsForClientDropDown.sort((a, b) => a.label.localeCompare(b.label));
          this.utilsService.unlockUi();
          this.route.paramMap.subscribe(params => {
            const id = params.get('id');
            if (id) {
              this.selectedClientUniqid = id;
              this.changeClient();
            }
          });
        }, () => {
          return;
        }
      );
  }

  showTables() {
    return !this.isMckayUser || this.selectedClient;
  }

  changeClient() {
    if (this.selectedClientUniqid === null) {
      this.selectedClient = null;
    }
    const client = this.listClients.find(company => company.uniqid === this.selectedClientUniqid);
    if (client) {
      this.selectedClient = client;
      this.loadTables(client);
    }
  }

  customSort($event) {
    this.tableService.customSort($event);
  }

  toggleCoi(coi: any) {
    coi.expanded = !coi.expanded;
  }

  getCoiStatusClass(status: string): string {
    const value = (status || '').toLowerCase();
    if (value.includes('expired') || value.includes('invalid') || value.includes('inactive') || value.includes('rejected')) {
      return 'coi-status-bad';
    }
    if (value.includes('active') || value.includes('valid')) {
      return 'coi-status-good';
    }
    if (value.includes('pending') || value.includes('review') || value.includes('expiring')) {
      return 'coi-status-warn';
    }
    return 'coi-status-neutral';
  }
}
